/* eslint-disable react/prop-types */
import React from "react";
import OtpInput from "react-otp-input";
import "./login.css";

function OTP({ otp, handleChange }) {
  return (
    <div style={{ padding: "10px" }}>
      <OtpInput
        value={otp}
        onChange={handleChange}
        numInputs={6}
        shouldAutoFocus={true}
        inputType="number"
        renderInput={(inputProps, index) => (
          <input
            {...inputProps}
            style={{
              border: "1px solid #E7ECF4",
              borderRadius: "8px",
              width: "40px",
              height: "40px",
              fontSize: "16px",
              color: "#000",
              fontWeight: "600",
              caretColor: "blue",
              background: "#fafafc",
              textAlign: "center",
              marginRight: index < 5 ? "8px" : "0"
            }}
            onFocus={(e) => {
              e.target.style.border = "1px solid #CFD3DB";
              e.target.style.outline = "none";
              e.target.style.color = "blue";
            }}
            onBlur={(e) => {
              e.target.style.border = "1px solid #E7ECF4";
              e.target.style.color = "#000";
            }}
          />
        )}
      />
    </div>
  );
}

export default OTP;
